import { Loading } from '@transferz/components';
import { LocalizationProvider } from 'localize-react';
import React from 'react';

import { resources } from '../../../i18n';
import { useQueryTranslations } from '../../../queries/translations/hooks/useQueryTranslations';
import { Toaster } from '../../shared/Toaster/Toaster';

interface IAppLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const AppLayout: React.FunctionComponent<IAppLayoutProps> = ({ children, className = '' }) => {
  const browserLanguage: string = navigator?.language?.split('-')[0];
  let lng: string = Object.prototype.hasOwnProperty.call(resources, browserLanguage) ? browserLanguage : 'en';
  const preferredLanguage = localStorage.getItem('preferredLanguage');
  if (preferredLanguage) {
    lng = JSON.parse(preferredLanguage);
  }
  const { data: translationsData, loading: isTranslationLoading } = useQueryTranslations({
    variables: {
      app: 'backoffice-portal',
      lng: lng,
    },
    fetchPolicy: 'no-cache',
  });

  const translations = {
    en: translationsData?.translations?.content,
  };

  if (isTranslationLoading) {
    return <Loading />;
  }

  return (
    <LocalizationProvider
        disableCache
        locale="en"
        translations={translations}
    >
      <div className={`c-app ${className}`}>
        <Toaster>
          {children}
        </Toaster>
      </div>
    </LocalizationProvider>
  );
};
